import React, { forwardRef, useCallback } from "react";
import { StyledSearchBar, StyledSearchInput } from "./styled";
import { locale } from "../../utils/LocaleManager";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { useContentStore } from "../../stores/contentStore";
import ClearIcon from "@mui/icons-material/Clear";
import { debounce } from "lodash";

const SearchBar = forwardRef<HTMLInputElement>((props, ref) => {
  const searchKeywordTemp = useContentStore(
    (state: any) => state.searchKeywordTemp,
  );
  const setSearchKeyword = useContentStore(
    (state: any) => state.setSearchKeyword,
  );
  const setSearchKeywordTemp = useContentStore(
    (state: any) => state.setSearchKeywordTemp,
  );
  const setSelectedThumbnails = useContentStore(
    (state: any) => state.setSelectedThumbnails,
  );
  const setIsLoading = useContentStore((state: any) => state.setIsLoading);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearchKeyword = useCallback(
    debounce((value) => {
      setSearchKeyword(value);
      setIsLoading(false);
    }, 2000),
    [setSearchKeyword, setIsLoading],
  );

  const handleClear = useCallback(() => {
    setIsLoading(true);
    setSearchKeyword("");
    setSearchKeywordTemp("");
    setSelectedThumbnails([]);
    setIsLoading(false);
  }, [
    setIsLoading,
    setSearchKeyword,
    setSearchKeywordTemp,
    setSelectedThumbnails,
  ]);

  const handleSearchChange = useCallback(
    (e: any) => {
      const searchValue = e.target.value ?? "";

      if (!searchValue.length || searchValue.length === 1) {
        setSearchKeywordTemp(searchValue);
        return;
      }

      setIsLoading(true);
      setSearchKeywordTemp(searchValue);
      setSelectedThumbnails([]);

      if (!searchValue.length || searchValue.length > 1) {
        debouncedSetSearchKeyword(searchValue);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      setIsLoading,
      setSearchKeyword,
      setSearchKeywordTemp,
      setSelectedThumbnails,
      debouncedSetSearchKeyword,
    ],
  );

  return (
    <StyledSearchBar>
      <StyledSearchInput
        value={searchKeywordTemp}
        {...props}
        ref={ref}
        placeholder={locale.search_here}
        color="primary"
        InputProps={{
          endAdornment: searchKeywordTemp.length ? (
            <InputAdornment position="end">
              <ClearIcon
                color="info"
                style={{ cursor: "pointer" }}
                onClick={handleClear}
              />
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <SearchIcon color="info" />
            </InputAdornment>
          ),
        }}
        onChange={handleSearchChange}
      />
    </StyledSearchBar>
  );
});

export default SearchBar;
